import { HealthData } from '../Enums/HealthData.enum';

export interface ChartDatasetColor {
	key: string;
	pointBackgroundColor: string;
	borderColor: string;
	backgroundColor: string;
}

export const chartDatasetColors: ChartDatasetColor[] = [
	{
		key: HealthData.BLOOD_PRESSURE_SYSTOLIC,
		pointBackgroundColor: '#ffffff',
		borderColor: 'rgb(97, 150, 18)',
		backgroundColor: 'rgba(97, 150, 18, 0.05)',
	},
	{
		key: HealthData.BLOOD_PRESSURE_DIASTOLIC,
		pointBackgroundColor: '#ffffff',
		borderColor: 'rgb(255, 94, 0)',
		backgroundColor: 'rgba(255, 94, 0, 0.05)',
	},
	{
		key: HealthData.HEARTH_RATE,
		pointBackgroundColor: '#ffffff',
		borderColor: 'rgb(255,213,0)',
		backgroundColor: 'rgba(255,213,0, 0.05)',
	},
	{
		key: HealthData.WEIGHT,
		pointBackgroundColor: '#ffffff',
		borderColor: '#3a96fd',
		backgroundColor: 'rgba(58, 150, 253, 0.05)',
	},
	{
		key: HealthData.HEIGHT,
		pointBackgroundColor: '#ffffff',
		borderColor: '#154172',
		backgroundColor: 'rgba(21,65,114,0.05)',
	},
	{
		key: HealthData.WAISTLINE,
		pointBackgroundColor: '#ffffff',
		borderColor: '#3a96fd',
		backgroundColor: 'rgba(58, 150, 253, 0.05)',
	},
	{
		key: HealthData.BLOOD_GLUCOSE,
		pointBackgroundColor: '#ffffff',
		borderColor: 'rgb(212, 0, 0)',
		backgroundColor: 'rgba(212, 0, 0, 0.05)',
	},
	{
		key: HealthData.BLOOD_GLUCOSE_EXTRA,
		pointBackgroundColor: '#ffffff',
		borderColor: 'rgb(212, 0, 0)',
		backgroundColor: 'transparent',
	},
	{
		key: HealthData.BLOOD_GLUCOSE_FASTING,
		pointBackgroundColor: '#ffffff',
		borderColor: 'rgb(97, 150, 18)',
		backgroundColor: 'transparent',
	},
	{
		key: HealthData.BLOOD_GLUCOSE_BEFORE_BREAKFAST,
		pointBackgroundColor: '#ffffff',
		borderColor: 'rgb(255,213,0)',
		backgroundColor: 'transparent',
	},
	{
		key: HealthData.BLOOD_GLUCOSE_BEFORE_LUNCH,
		pointBackgroundColor: '#ffffff',
		borderColor: 'rgb(255, 94, 0)',
		backgroundColor: 'transparent',
	},
	{
		key: HealthData.BLOOD_GLUCOSE_BEFORE_DINNER,
		pointBackgroundColor: '#ffffff',
		borderColor: '#3a96fd',
		backgroundColor: 'transparent',
	},
	{
		key: HealthData.BLOOD_GLUCOSE_AFTER_BREAKFAST,
		pointBackgroundColor: '#ffffff',
		borderColor: '#d0176c',
		backgroundColor: 'transparent',
	},
	{
		key: HealthData.BLOOD_GLUCOSE_AFTER_LUNCH,
		pointBackgroundColor: '#ffffff',
		borderColor: 'rgb(0,22,255)',
		backgroundColor: 'transparent',
	},
	{
		key: HealthData.BLOOD_GLUCOSE_AFTER_DINNER,
		pointBackgroundColor: '#ffffff',
		borderColor: 'rgb(183,182,95)',
		backgroundColor: 'transparent',
	},
	{
		key: HealthData.BLOOD_GLUCOSE_BEFORE_SLEEP,
		pointBackgroundColor: '#ffffff',
		borderColor: 'rgb(0,205,212)',
		backgroundColor: 'transparent',
	},
	{
		key: HealthData.BLOOD_GLUCOSE_BEFORE_WORKOUT,
		pointBackgroundColor: '#ffffff',
		borderColor: 'rgb(117,0,212)',
		backgroundColor: 'transparent',
	},
	{
		key: HealthData.BLOOD_GLUCOSE_3AM,
		pointBackgroundColor: '#ffffff',
		borderColor: 'rgb(212,88,0)',
		backgroundColor: 'transparent',
	},
	{
		key: HealthData.STEP_COUNT,
		pointBackgroundColor: '#ffffff',
		borderColor: '#6d16d8',
		backgroundColor: 'rgba(109,22,216,0.05)',
	},
	{
		key: HealthData.BREATHING_RATE,
		pointBackgroundColor: '#ffffff',
		borderColor: '#e39d58',
		backgroundColor: 'rgba(227,157,88,0.05)',
	},
	{
		key: HealthData.OXYGEN_SATURATION,
		pointBackgroundColor: '#ffffff',
		borderColor: '#90e2f1',
		backgroundColor: 'rgba(144,226,241,0.05)',
	},
	{
		key: HealthData.SLEEP,
		pointBackgroundColor: '#ffffff',
		borderColor: '#3c3052',
		backgroundColor: 'rgba(60,48,82,0.05)',
	},
	{
		key: HealthData.HEMOGLOBIN,
		pointBackgroundColor: '#ffffff',
		borderColor: '#84e193',
		backgroundColor: 'rgba(132,225,147,0.05)',
	},
	{
		key: HealthData.HEMOGLOBIN_A1C,
		pointBackgroundColor: '#ffffff',
		borderColor: '#84e1c8',
		backgroundColor: 'rgba(132,225,200,0.05)',
	},
	{
		key: HealthData.STRESS_LEVEL,
		pointBackgroundColor: '#ffffff',
		borderColor: '#e184df',
		backgroundColor: 'rgba(225,132,223,0.05)',
	},
	{
		key: HealthData.ACTIVE_ENERGY,
		pointBackgroundColor: '#ffffff',
		borderColor: '#f56838',
		backgroundColor: 'rgba(245,104,56,0.05)',
	},
	{
		key: HealthData.DISTANCE_WALKING_RUNNING,
		pointBackgroundColor: '#ffffff',
		borderColor: '#f5d91e',
		backgroundColor: 'rgba(245,217,30,0.05)',
	},
	{
		key: HealthData.WORKOUT,
		pointBackgroundColor: '#ffffff',
		borderColor: '#327229',
		backgroundColor: 'rgba(50,114,41,0.05)',
	},

	{
		key: 'esasCelkovapohoda',
		pointBackgroundColor: '#ffffff',
		borderColor: 'rgb(212, 0, 0)',
		backgroundColor: 'transparent',
	},
	{
		key: 'esasBolest',
		pointBackgroundColor: '#ffffff',
		borderColor: 'rgb(97, 150, 18)',
		backgroundColor: 'transparent',
	},
	{
		key: 'esasUnava',
		pointBackgroundColor: '#ffffff',
		borderColor: 'rgb(255,213,0)',
		backgroundColor: 'transparent',
	},
	{
		key: 'esasOspalost',
		pointBackgroundColor: '#ffffff',
		borderColor: 'rgb(255, 94, 0)',
		backgroundColor: 'transparent',
	},
	{
		key: 'esasNevolnost',
		pointBackgroundColor: '#ffffff',
		borderColor: '#3a96fd',
		backgroundColor: 'transparent',
	},
	{
		key: 'esasNechutenstvi',
		pointBackgroundColor: '#ffffff',
		borderColor: '#ff5ea6',
		backgroundColor: 'transparent',
	},
	{
		key: 'esasDusnost',
		pointBackgroundColor: '#ffffff',
		borderColor: 'rgb(0,22,255)',
		backgroundColor: 'transparent',
	},
	{
		key: 'esasDeprese',
		pointBackgroundColor: '#ffffff',
		borderColor: 'rgb(183,182,95)',
		backgroundColor: 'transparent',
	},
	{
		key: 'esasUzkost',
		pointBackgroundColor: '#ffffff',
		borderColor: 'rgb(0,205,212)',
		backgroundColor: 'transparent',
	},
	{
		key: 'esasJinyproblem',
		pointBackgroundColor: '#ffffff',
		borderColor: 'rgb(117,0,212)',
		backgroundColor: 'transparent',
	},
	{
		key: 'psychoStrach,tisen,uzkost',
		pointBackgroundColor: '#ffffff',
		borderColor: 'rgb(212,88,0)',
		backgroundColor: 'transparent',
	},
	{
		key: 'psychoDepresivita',
		pointBackgroundColor: '#ffffff',
		borderColor: 'rgb(173,212,0)',
		backgroundColor: 'transparent',
	},
	{
		key: 'psychoZvladanisituace',
		pointBackgroundColor: '#ffffff',
		borderColor: 'rgb(0,212,212)',
		backgroundColor: 'transparent',
	},
];
